import { UUID } from "@/interfaces/uuid/uuid";
import { IRecipeBuilder } from "./recipe_builder";

export interface IRecipe extends IRecipeBuilder {
    id: UUID;
    title: string;
    description?: string;
    image: string|null;
    prep_time: number;
    servings: number;
    draft: boolean;
}

export const getFormData = (data: IRecipe) => {
    const formData = new FormData();
    formData.append('draft', String(data.draft));
    formData.append('title', String(data.title));
    formData.append('description', String(data.description));
    formData.append('prep_time', String(data.prep_time));
    formData.append('cook_time', String(data.cook_time));
    formData.append('servings', String(data.servings));
    formData.append('categories', JSON.stringify(data.categories));
    formData.append('diet', JSON.stringify(data.diet));
    formData.append('allergens', JSON.stringify(data.allergens));
    formData.append('cuisine', String(data.cuisine));
    formData.append('calories', String(data.calories));
    formData.append('protein', String(data.protein));
    formData.append('carbs', String(data.carbs));
    formData.append('fat', String(data.fat));
    formData.append('fibre', String(data.fibre));
    formData.append('alcohol', String(data.alcohol));
    formData.append('ingredients', JSON.stringify(data.ingredients));
    formData.append('instructions', JSON.stringify(data.instructions));
    return formData;
}